import { Avatar, createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { colorPalette, spacings, TextSizesEnum } from '../../../theme';
import { PlexTypography } from '../../shared/primitives/PlexTypography';

type Props = {
  className?: string;
  authorAvatar?: string;
  authorName: string;
  authorTitle: string | null | undefined;
};

export function PostAuthorTooltipContent(props: Props): React.ReactElement {
  const { authorAvatar, authorName, authorTitle, className } = props;
  const classes = useStyles();

  // TODO set correct job title (using the author's jobTitle)
  return (
    <div className={classNames(classes.root, className)}>
      <Avatar className={classes.avatar} src={authorAvatar} alt={authorName} />
      <PlexTypography className={classes.authorName} text={authorName} size={TextSizesEnum.Small} />
      <PlexTypography
        className={classes.authorEmploymentTitle}
        text={authorTitle || 'Employee'}
        size={TextSizesEnum.Small}
      />
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: spacings.normal,
    },
    avatar: {
      display: 'flex',
      marginRight: spacings.small,
      width: 24,
      height: 24,
    },
    authorName: {
      color: colorPalette.purpleGray._500,
      fontWeight: 'bold',
    },
    authorEmploymentTitle: {
      color: colorPalette.purpleGray._500,
      fontWeight: 500,
      marginLeft: spacings.xsmall,
    },
  })
);
